module.exports = __webpack_public_path__ + "static/growth-38855e3ceb8b4571ae78fd96d7376db1.png";